import { useQuery } from "@tanstack/react-query";
import { getAllBusinessVerificationSections } from "app/api/business_verification";
import parseError from "app/lib/parseError";
import { useActiveProfile } from "app/providers/ActiveProfileProvider";
import { useActiveCustomerAccount } from "app/providers/ActiveCustomerAccountProvider";
import { AxiosError } from "axios";
import { GET_BUSINESS_VERIFICATION_QUERY } from "app/constants/commonQueries";

const useGetAllBusinessVerificationSections = () => {
  const activeProfile = useActiveProfile();
  const activeCustomerAccount = useActiveCustomerAccount();

  const {
    isInitialLoading: isLoading,
    data,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryFn: getAllBusinessVerificationSections,
    queryKey: [GET_BUSINESS_VERIFICATION_QUERY],
    enabled:
      activeCustomerAccount?.type === "business" ||
      (!activeCustomerAccount && activeProfile?.profile_type === "business"),
  });

  return {
    isLoading,
    isFetching,
    error: error ? (parseError(error as AxiosError<any>) as string) : undefined,
    getSections: refetch,
    sections: data?.data.data.sections,
    level: data?.data.data.level,
  };
};

export default useGetAllBusinessVerificationSections;
